import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=6a2be8a2&scoped=true&"
import script from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
export * from "./LoadingOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=6a2be8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2be8a2",
  null
  
)

export default component.exports